var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{staticStyle:{"height":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }